// extracted by mini-css-extract-plugin
module.exports = {"content":"Tooltip_content__KbRxz","arrow":"Tooltip_arrow__V8QL8","tooltipHidden":"Tooltip_tooltipHidden__8f2Lr"};